<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/divergencias">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <!-- <v-row
            v-if="dataset.data.status == 0 && (!dataset.data.currentReview || dataset.data.currentReview.status !== 0) && $check(user, ['userevent.view.analysisstatus'])">
            <v-col>
                <v-banner single-line outlined>
                    <v-icon slot="icon" color="warning" size="36">
                        mdi-alert-outline
                    </v-icon>

                    Esta {{ dataset.data.user.uuid_ref ? 'divergência' : 'habilitação' }} ainda não foi analisada

                </v-banner>
            </v-col>
        </v-row> -->

        <v-row
            v-if="dataset.data.currentReview && dataset.data.currentReview.status == 0 && $check(user, ['events.view.analysisstatus'])">
            <v-col>
                <v-banner single-line outlined>
                    <v-icon slot="icon" color="warning" size="36">
                        mdi-alert-outline
                    </v-icon>

                    Este pedido está em revisão. Por favor, realize a análise e finalize o processo.

                </v-banner>
            </v-col>
        </v-row>

        <v-row v-if="dataset.data.status == 4 && $check(user, ['events.view.analysisstatus'])">
            <v-col>
                <v-banner single-line outlined>
                    <v-icon slot="icon" color="warning" size="36">
                        mdi-alert-outline
                    </v-icon>

                    Pedido aguardando documentos solicitados.

                </v-banner>
                <!-- Prazo até {{
                   $moment(dataset.data.requested_doc_at).add(72, 'hours').toDate() |
                   defaultDate('DD/MM/YYYY [às] HH:mm')
               }} -->
            </v-col>
        </v-row>

        <v-row
            v-if="dataset.data.status !== 0 && dataset.data.status !== 4 && dataset.data.status !== 5 && dataset.data.status !== 6">
            <v-col>
                <v-banner single-line outlined>

                    <div class="d-flex justify-space-between align-center">
                        <div>
                            Esta divergência foi marcada como <span class="text-uppercase"> <strong>{{
                                dataset.data.status === 1
                                    ? 'aprovada'
                                    : (dataset.data.status === 2
                                        ? 'rejeitada'
                                        : (dataset.data.status === 3
                                            ? 'aprovada parcialmente'
                                            : ''
                                        )
                                    )
                            }}</strong>

                            </span> por
                            <span class="text-uppercase"> <strong>
                                    {{
                                        dataset.data.admin
                                            ? dataset.data.admin.name
                                            : dataset.data.analyzed_at !== "0000-00-00 00:00:00" && !dataset.data.admin
                                                ? "SISTEMA"
                                                : "N/A"
                                    }}
                                </strong></span>

                        </div>

                        <!-- <div class="icon-container">
                            <v-tooltip bottom>
                                <template #activator="{ on }">
                                    <v-icon icon v-on="on" @click="statusReset()" size="large" class="border ">
                                        mdi-reload
                                    </v-icon>
                                </template>
<span>Restaurar pedido</span>
</v-tooltip>
</div> -->
                    </div>
                </v-banner>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm" v-if="dataset.data && dataset.data.user">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes credor</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense disabled id="name" label="Nome completo"
                                                v-model="dataset.data.user.name" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense disabled label="E-mail"
                                                v-model="dataset.data.user.email" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense disabled label="CPF/CNPJ"
                                                v-model="dataset.data.user.registration" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="3">
                                            <v-text-field dense id="uuid" label="Classe"
                                                :value="dataset.data.creditor ? dataset.creditorTypes.find((x) => x.id == dataset.data.creditor.type).name : 'N/A'"
                                                outlined hide-details="auto" disabled>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="3">
                                            <v-text-field dense id="uuid" label="Valor arrolado"
                                                :value="dataset.data.creditor ? 'R$ ' + parseFloat(dataset.data.creditor.amount).toFixed(2) : 'N/A'"
                                                outlined hide-details="auto" disabled>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row v-if="dataset.data.lawyer">
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Nome procurador"
                                                v-model="dataset.data.lawyer.name" outlined hide-details="auto"
                                                disabled>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="E-mail procurador"
                                                v-model="dataset.data.lawyer.email" outlined hide-details="auto"
                                                disabled>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="OAB procurador"
                                                v-model="dataset.data.lawyer.federal_registration" outlined
                                                hide-details="auto" disabled>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="UF procurador"
                                                v-model="dataset.data.lawyer.federal_registration_uf" outlined
                                                hide-details="auto" disabled>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row class="mt-4" dense v-if="dataset && dataset.data && (dataset.data.user.url_document || (dataset.data.lawyer && (dataset.data.lawyer.url_document || dataset.data.lawyer.url_procuration)))
                                        && $check(user, ['events.update.files'])">
                                        <v-col cols="10">
                                            <v-row gutter="10">
                                                <v-col cols="2" sm="4" md="3" class="mr-5"
                                                    v-if="dataset && dataset.data && dataset.data.user && dataset.data.user.url_document">
                                                    <div class="document-container">
                                                        <a :href="dataset.data.user.url_document" target="_blank"
                                                            rel="noopener noreferrer" class="overlay-link">
                                                        </a>
                                                        <iframe :src="dataset.data.user.url_document"
                                                            class="document-frame rounded-xl"></iframe>
                                                    </div>
                                                    <div class="text-left caption-text">DOCUMENTO CREDOR</div>
                                                </v-col>
                                                <v-col cols="2" sm="4" md="3" class="mr-5"
                                                    v-if="dataset && dataset.data && dataset.data.lawyer && dataset.data.lawyer.url_document">
                                                    <div class="document-container">
                                                        <a :href="dataset.data.lawyer.url_document" target="_blank"
                                                            rel="noopener noreferrer" class="overlay-link">
                                                        </a>
                                                        <iframe :src="dataset.data.lawyer.url_document"
                                                            class="document-frame rounded-xl"></iframe>
                                                    </div>
                                                    <div class="text-left caption-text">DOCUMENTO PROCURADOR</div>
                                                </v-col>
                                                <v-col cols="2" sm="4" md="3" class="mr-5"
                                                    v-if="dataset && dataset.data && dataset.data.lawyer && dataset.data.lawyer.url_procuration">
                                                    <div class="document-container">
                                                        <a :href="dataset.data.lawyer.url_procuration" target="_blank"
                                                            rel="noopener noreferrer" class="overlay-link">
                                                        </a>
                                                        <iframe :src="dataset.data.lawyer.url_procuration"
                                                            class="document-frame rounded-xl"></iframe>
                                                    </div>
                                                    <div class="text-left caption-text">DOCUMENTO PROCURAÇÃO</div>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>

        <v-row v-if="dataset.data && dataset.data.user">
            <v-col>
                <v-card outlined>
                    <v-card-text>
                        <v-row class="align-center">
                            <v-col cols="12" sm="6" class="d-flex align-center mt-n5">
                                <v-checkbox v-model="dataset.data.review_later" label="Sinalizar pedido" hide-details
                                    @change="saveReviewLater"></v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-select dense :items="dataset.qgcRuleTypes" label="Regra"
                                    v-model="dataset.data.user_creditor_rule" item-value="id" item-text="name" outlined
                                    @change="saveSelectedRule" hide-details="auto"></v-select>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- <v-row v-if="dataset.data.status == 0">
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Ações</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-btn type="button" elevation="0" color="accent" class="mr-5"
                                    @click="updateStatus('approve')">Aprovar</v-btn>

                                <v-btn type="button" elevation="0" color="indigo darken-1" class="mr-5 white--text"
                                    @click="updateStatus('partial')">Aprovar Parcialmente</v-btn>

                                <v-btn type="button" elevation="0" color="error" class="mr-5"
                                    @click="updateStatus('reject')">Rejeitar</v-btn>

                                <v-btn type="button" elevation="0" color="#7E55AB" class="mr-5 white--text"
                                    @click.stop="openRequestDoc()">Solicitar Documento</v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row> -->

        <v-row v-if="$check(user, ['events.update.contradictory'])">
            <v-col cols="12">
                <v-row>
                    <v-col cols="12">
                        <v-card class="card-form-outlined" color="gray">
                            <v-card-title class="card-group-title">
                                <div class="title-container">
                                    <div class="title-block">
                                        <span id="title" class="table-card-title">Contraditórios</span>
                                    </div>
                                </div>
                            </v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-text-field dense type="date" label="Prazo contraditório"
                                            :value="formatDate(dataset.data.contradictory_deadline_at)"
                                            @input="updateContraditory" outlined hide-details="auto"
                                            :disabled="!($check(user, ['events.update.contradictory']))">
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-btn :loading="dataset.loading" type="button" elevation="0" color="primary"
                                            @click="updateContradictoryDeadline()"
                                            :disabled="!($check(user, ['events.update.contradictory']))">Salvar</v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-card-text>
                                <v-divider></v-divider>
                            </v-card-text>
                            <v-card-text>
                                <span v-if="!dataset.data.contradictory_reason">Nenhum contraditório encontrado</span>
                                <template v-else>
                                    <strong>Resultado: </strong> <v-chip small label class="mr-10"
                                        :color="getColorByStatus(dataset.data.contradictory_status)">
                                        {{ dataset.data.contradictory_status | enum(dataset.eventStatus, 'id',
                                            'name') }}
                                    </v-chip>
                                    <br />
                                    <strong>Enviado em: </strong>
                                    <span v-if="dataset.data.contradictory_status_at">{{
                                        dataset.data.contradictory_status_at | defaultDate('DD/MM/YYYY')
                                        }}</span>
                                    <br />
                                    <br />
                                    <strong>Valor indicado: </strong>
                                    <span v-if="dataset.data.contradictory_amount">
                                        {{ dataset.data.contradictory_amount | currency }}
                                    </span>
                                    <span v-else>N/A</span>
                                    <br />
                                    <br />
                                    <strong>Documentos: </strong>
                                    <template v-if="dataset.data.contradictory_docs">
                                        <br />
                                        <span v-for="(item, index) in resolveContradictoryDocs()" :key="index">
                                            - <a :href="item">{{ item }}</a><br />
                                        </span>
                                    </template>
                                    <span v-else>N/A</span>
                                    <br />
                                    <br />
                                    <strong>Motivo </strong>
                                    <br />
                                    <div v-html="dataset.data.contradictory_reason"></div>
                                </template>
                            </v-card-text>
                            <v-card-text v-if="dataset.data.contradictory_reason_file_url">
                                <v-btn type="button" elevation="0" color="primary" outlined
                                    :href="dataset.data.contradictory_reason_file_url" target="_blank">Visualizar
                                    documento
                                </v-btn>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row v-if="$check(user, ['events.update.process'])">
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Processos</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <template v-if="dataset.data && dataset.data.processes.length > 0">
                            <v-expansion-panels>
                                <v-expansion-panel v-for="(process) in dataset.data.processes" :key="process.id">
                                    <v-expansion-panel-header>
                                        <div class="d-flex align-center">
                                            <strong>Número: </strong>
                                            <span class="ml-2 mr-2">
                                                {{ process.number }}
                                            </span>
                                            <v-spacer></v-spacer>
                                            <v-icon @click="copyToClipboard(process.number)"
                                                :disabled="!($check(user, ['events.update.process']))">mdi-content-copy</v-icon>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <p><strong>Local:</strong> {{ process.local }}</p>
                                        <p><strong>Tribunal:</strong> {{ process.court }}</p>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </template>
                        <template v-else>
                            <v-row>
                                <v-col>
                                    <span>Nenhum processo encontrado</span>
                                </v-col>
                            </v-row>
                        </template>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Relatórios</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text v-if="dataset.loadingReport">
                        <v-progress-circular indeterminate color="primary" size="64" width="4"></v-progress-circular>
                    </v-card-text>
                    <v-card-text v-if="!dataset.loadingReport && dataset.reports && dataset.reports.length">
                        <v-row v-for="(item, index) in dataset.reports" :key="index">
                            <v-col>
                                <v-row>
                                    <v-col>
                                        <strong>Modelo: </strong> {{ item.type.name || 'n/a' }}
                                        <br />
                                        <strong>Arquivo: </strong> {{ item.file.name || 'n/a' }}
                                        <br />
                                        <strong>Caso: </strong> {{ item.file.client.name || 'n/a' }}
                                        <br />
                                        <span v-for="(valueItem, index) in item.values" :key="index">
                                            <strong>{{ valueItem.column.label }}: </strong> {{ valueItem.value || 'n/a'
                                            }}
                                            <br />
                                        </span>
                                        <br />
                                        <v-divider v-if="index + 1 !== dataset.reports.length"></v-divider>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-text v-if="!dataset.loadingReport && !dataset.reports.length">
                        <v-row>
                            <v-col cols="12">
                                Nenhum relatório encontrado
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row v-if="dataset.data.currentReview && $check(user, ['events.view.review'])">
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Revisão</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-row>
                                    <v-col>
                                        <strong>Resultado: </strong> <span>{{ dataset.data.currentReview.status |
                                            enum(dataset.eventStatus, 'id', 'name') }}</span>
                                        <br />
                                        <strong>Revisado em: </strong>
                                        <span v-if="dataset.data.currentReview.reviewed_at">{{
                                            dataset.data.currentReview.reviewed_at | defaultDate('DD/MM/YYYY')
                                            }}</span>
                                        <span v-else>N/A</span>
                                        <br />
                                        <strong>Revisado por: </strong>
                                        <span>{{
                                            dataset.data.currentReview.reviewed_by ?
                                                dataset.data.currentReview.admin.name :
                                                'N/A'
                                        }}</span>
                                        <br />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Negócios</span>
                            </div>
                            <v-col cols="3">
                                <v-progress-linear :value="dataset.loading ? undefined : progress" color="green"
                                    height="20" rounded :indeterminate="dataset.loading">
                                    <strong v-if="!dataset.loading" class="centered">{{ progress }}% analisados</strong>
                                    <span v-else class="centered">Carregando...</span>
                                </v-progress-linear>

                            </v-col>
                        </div>

                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-row>
                                    <v-col>
                                        <strong>Habilitação/Divergência</strong>
                                        <br />
                                        <strong>Devedora: </strong> <span>{{ dataset.data.client ?
                                            dataset.data.client.name
                                            : '' }}</span>
                                        <br />
                                        <strong>Solicitado em: </strong>
                                        <span>{{
                                            dataset.data.created_at | defaultDate('DD/MM/YYYY HH:mm:ss')
                                            }}</span>
                                        <br />
                                        <!--
                                        <v-row>
                                            <v-col cols="3">
                                                <strong>Total de casos analisados: </strong>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-progress-linear :value="progress" color="green" height="20"
                                                    class="mb-3" rounded>
                                                    <strong>{{ progress }}%</strong>
                                                </v-progress-linear>
                                            </v-col>
                                        </v-row>
                                        --->

                                    </v-col>
                                </v-row>
                                <v-row v-if="!dataset.loading">
                                    <v-col>
                                        <strong>Resultado: </strong>
                                        <v-chip small label class="mr-10" :color="getColorByStatus(getFinalStatus())">
                                            {{ getFinalStatus() | enum(dataset.eventStatus, 'id',
                                                'name') }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                                <v-row
                                    v-if="!dataset.loading && (!dataset.data.currentReview || dataset.data.currentReview.status !== 0)">
                                    <v-col>
                                        <v-btn type="button" elevation="0" color="#B39DDB" class="mr-5" small v-if="(dataset.data.status && dataset.data.status !== 4 && dataset.data.status !== 5 && dataset.data.status !== 6)
                                            || !($check(user, ['events.restore']))"
                                            @click="statusReset()">Restaurar</v-btn>

                                        <v-btn type="button" elevation="0" color="accent" class="mr-5" small
                                            :disabled="(dataset.data.status !== 0 && dataset.data.status !== 4 && dataset.data.status !== 5 && dataset.data.status !== 6) || !getFinalStatus()"
                                            @click="updateStatus()">Confirmar</v-btn>

                                        <v-btn type="button" elevation="0" color="#FF8F00" small :disabled="(dataset.data.status !== 0 && dataset.data.status !== 4 && dataset.data.status !== 5 && dataset.data.status !== 6)
                                            || !($check(user, ['events.create.eventitem.review']))"
                                            @click="createReview()" class="mr-5">Enviar
                                            para revisão</v-btn>

                                        <v-btn type="button" elevation="0" color="#7E55AB" class="mr-5 white--text"
                                            small :disabled="(dataset.data.status !== 0 && dataset.data.status !== 4 && dataset.data.status !== 5 && dataset.data.status !== 6)
                                                || !($check(user, ['events.update.eventitem.docs']))"
                                            @click.stop="openRequestDoc()">Solicitar
                                            Documento</v-btn>

                                        <v-btn type="button" elevation="0" color="primary" class="mr-5 white--text"
                                            small :disabled="(dataset.data.status !== 0 && dataset.data.status !== 4 && dataset.data.status !== 5 && dataset.data.status !== 6)
                                                || !($check(user, ['events.create.eventitem']))"
                                            @click.stop="openCreateBusinessModal()">Adicionar
                                            Negócio</v-btn>
                                    </v-col>
                                </v-row>

                                <v-row v-if="!dataset.loading && dataset.data.currentReview && dataset.data.currentReview.status == 0
                                    && $check(user, ['events.update.eventitem.action'])">
                                    <v-col>
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-btn v-on="on" type="button" elevation="0" color="accent" class="mr-5"
                                                    small @click="updateReview(1)">Aprovar</v-btn>
                                            </template>
                                            <span>Clique no botão para aprovar a revisão.</span>
                                        </v-tooltip>

                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-btn v-on="on" type="button" elevation="0" color="error" class="mr-5"
                                                    small @click="updateReview(2)">Rejeitar</v-btn>
                                            </template>
                                            <span>Clique no botão para rejeitar a revisão.</span>
                                        </v-tooltip>

                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <div>
                                            <div v-if="dataset.loading" class="loading-container">
                                                <v-progress-circular indeterminate color="green" size="50"
                                                    class="my-5"></v-progress-circular>
                                                <span>Carregando...</span>
                                            </div>
                                            <v-expansion-panels v-else>

                                                <v-expansion-panel v-for="(eventItem, eventIndex) in dataset.data.items"
                                                    :key="eventIndex">

                                                    <!-- <div
                                                        :class="eventItem.isChecked ? 'checkbox-marked-wrapper' : 'checkbox-wrapper'">
                                                        <v-checkbox v-model="eventItem.isChecked" class="ml-3"
                                                            color="green"
                                                            @change="toggleCheckbox(eventItem)"></v-checkbox>
                                                    </div> -->

                                                    <v-expansion-panel-header @click.stop>
                                                        <div class="d-flex align-center">
                                                            <div>
                                                                <strong>ID: </strong>
                                                                <span class="ml-2 mr-2">#{{ eventItem.id }}</span> /
                                                                <strong>Origem: </strong>
                                                                <span class="ml-2 mr-2">{{ truncateText(eventItem.origin
                                                                    ||
                                                                    'N/A', 30) }}</span> /
                                                                <strong class="ml-2">Valor: </strong>
                                                                <span class="ml-2" v-if="eventItem.amount">
                                                                    {{ eventItem.currency | enum(dataset.currencyTypes,
                                                                        'id',
                                                                        'currencyFormat') }}
                                                                    {{ eventItem.amount | currency }}
                                                                </span>
                                                                <span v-else>N/A</span>
                                                            </div>

                                                            <v-spacer></v-spacer>

                                                            <v-chip label class="mr-10" small
                                                                :color="getColorByStatus(eventItem.status)"
                                                                style="color: white">
                                                                {{ eventItem.status | enum(dataset.eventStatus, 'id',
                                                                    'name') }}
                                                            </v-chip>

                                                            <template
                                                                v-if="!eventItem.isEditing && (dataset.data.status == 0 || dataset.data.status == 4 || dataset.data.status == 5) && (!dataset.data.currentReview || dataset.data.currentReview.status !== 0)">
                                                                <v-tooltip bottom :disabled="!eventItem.status">
                                                                    <template #activator="{ on }">
                                                                        <v-btn icon v-on="on"
                                                                            @click.stop="changeStatusEventItem(eventItem, 0)"
                                                                            :disabled="eventItem.status === 0 || eventItem.status === 4 || eventItem.status === 5
                                                                                || !($check(user, ['events.restore']))"
                                                                            size="large">
                                                                            <v-icon>mdi-refresh-circle</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Clique no botão para restaurar o status do
                                                                        negócio</span>
                                                                </v-tooltip>

                                                                <v-tooltip bottom>
                                                                    <template #activator="{ on }">
                                                                        <v-btn icon v-on="on"
                                                                            @click.stop="changeStatusEventItem(eventItem, eventItem.partial_amount ? 3 : 1)"
                                                                            size="large" :disabled="eventItem.status !== 0 && eventItem.status !== 5 && eventItem.status !== 4
                                                                                || !($check(user, ['events.action']))"
                                                                            :color="eventItem.partial_amount ? '#FF8F00' : 'green'">
                                                                            <v-icon>mdi-check-circle</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span v-if="!eventItem.partial_amount">
                                                                        Clique no botão para aprovar este negócio e
                                                                        confirmar as
                                                                        informações enviadas.
                                                                    </span>
                                                                    <span v-else>
                                                                        Clique no botão para aprovar parcialmente este
                                                                        negócio,
                                                                        confirmando-o com o valor atualizado,
                                                                        diferente do originalmente enviado.
                                                                    </span>
                                                                </v-tooltip>

                                                                <v-tooltip bottom>
                                                                    <template #activator="{ on }">
                                                                        <v-btn icon v-on="on"
                                                                            @click.stop="changeStatusEventItem(eventItem, 2)"
                                                                            :disabled="eventItem.status !== 0 && eventItem.status !== 5 && eventItem.status !== 4
                                                                                || !($check(user, ['events.action']))"
                                                                            size="large" color="red">
                                                                            <v-icon>mdi-close-circle</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Clique no botão para rejeitar este negócio
                                                                        caso as
                                                                        informações não atendam aos critérios
                                                                        necessários.</span>
                                                                </v-tooltip>

                                                                <v-tooltip bottom>
                                                                    <template #activator="{ on }">
                                                                        <v-btn icon v-on="on"
                                                                            @click.stop="editItem(eventItem, eventIndex)"
                                                                            :disabled="eventItem.status !== 0 && eventItem.status !== 5 && eventItem.status !== 4
                                                                                || !($check(user, ['events.update.eventitem']))"
                                                                            size="large" color="primary" class="me-2">
                                                                            <v-icon>mdi-pencil-circle</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Clique no botão para habilitar a edição dos
                                                                        campos deste
                                                                        negócio e atualizar as informações conforme
                                                                        necessário.</span>
                                                                </v-tooltip>
                                                            </template>

                                                            <div v-if="eventItem.isEditing"
                                                                class="button-group ml-auto mr-10">
                                                                <v-btn
                                                                    :disabled="!($check(user, ['events.update.eventitem']))"
                                                                    @click.stop="saveEdit(eventItem)" small
                                                                    elevation="0" color="primary">
                                                                    Salvar
                                                                </v-btn>
                                                                <v-btn @click.stop="cancelEditItem(eventItem)" small
                                                                    elevation="0" color="error">
                                                                    Cancelar
                                                                </v-btn>
                                                            </div>
                                                        </div>
                                                    </v-expansion-panel-header>

                                                    <v-expansion-panel-content>
                                                        <v-row>
                                                            <v-col>
                                                                <p>
                                                                    <span class="section-info-title">Devedora</span>
                                                                    <br />
                                                                    <template v-if="eventItem.isEditing">
                                                                        <v-row>
                                                                            <v-col cols="3">
                                                                                <v-autocomplete dense
                                                                                    :items="dataset.clients"
                                                                                    v-model="eventItem.company_name"
                                                                                    item-value="name" item-text="name"
                                                                                    outlined hide-details="auto"
                                                                                    required :rules="[$rules.required]"
                                                                                    no-data-text="Nenhuma devedora encontrada"></v-autocomplete>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span class="section-info-value text-uppercase">
                                                                            {{ eventItem.company_name }}
                                                                        </span>
                                                                    </template>
                                                                </p>
                                                                <p>
                                                                    <span class="section-info-title">Origem</span>
                                                                    <br />
                                                                    <template v-if="eventItem.isEditing">
                                                                        <v-row>
                                                                            <v-col cols="3">
                                                                                <v-select :disabled="dataset.loading"
                                                                                    dense id="origin"
                                                                                    :items="dataset.creditorOriginTypes"
                                                                                    label="Selecione a origem"
                                                                                    v-model="eventItem.origin"
                                                                                    item-value="name" item-text="name"
                                                                                    outlined hide-details="auto">
                                                                                </v-select>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span class="section-info-value text-uppercase">
                                                                            {{ eventItem.origin }}</span>
                                                                    </template>
                                                                </p>

                                                                <v-row>
                                                                    <v-col cols="3">
                                                                        <span class="section-info-title">Classe</span>
                                                                        <template v-if="eventItem.isEditing">
                                                                            <v-autocomplete dense
                                                                                :items="dataset.creditorTypes"
                                                                                v-model="eventItem.type" item-value="id"
                                                                                item-text="name" outlined
                                                                                hide-details="auto" required
                                                                                :rules="[$rules.required]"
                                                                                no-data-text="Nenhuma classe encontrada"
                                                                                @change="onAutocompleteChange(eventIndex)"
                                                                                :disabled="!($check(user, ['events.update.eventitem']))"></v-autocomplete>
                                                                        </template>
                                                                        <template v-else>
                                                                            <br />
                                                                            <span
                                                                                class="section-info-value text-uppercase">
                                                                                {{
                                                                                    getCreditorTypeName(eventItem.type)
                                                                                }}
                                                                            </span>
                                                                        </template>
                                                                    </v-col>
                                                                </v-row>

                                                                <br />
                                                                <p>
                                                                    <span class="section-info-title">Moeda</span>
                                                                    <br />
                                                                    <template v-if="eventItem.isEditing">
                                                                        <v-row>
                                                                            <v-col cols="3">
                                                                                <v-select :disabled="dataset.loading"
                                                                                    dense id="type"
                                                                                    :items="dataset.currencyTypes"
                                                                                    label="Selecione uma moeda"
                                                                                    v-model="eventItem.currency"
                                                                                    item-value="id" item-text="name"
                                                                                    outlined hide-details="auto">
                                                                                </v-select>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span class="section-info-value text-uppercase">
                                                                            {{
                                                                                eventItem.currency
                                                                                | enum(
                                                                                    dataset.currencyTypes,
                                                                                    'id',
                                                                                    'name'
                                                                                )
                                                                            }}
                                                                        </span>
                                                                    </template>
                                                                </p>

                                                                <template>
                                                                    <p>
                                                                        <span class="section-info-title">Valor indicado
                                                                            pelo credor</span>
                                                                        <br />
                                                                        <template>
                                                                            <span
                                                                                class="section-info-value text-uppercase">
                                                                                {{
                                                                                    eventItem.currency |
                                                                                enum(dataset.currencyTypes, 'id',
                                                                                    'currencyFormat')
                                                                                }}
                                                                                {{ eventItem.amount | currency }}
                                                                            </span>
                                                                        </template>
                                                                    </p>
                                                                    <p>
                                                                        <span class="section-info-title">Valor definido
                                                                            pelo
                                                                            AJ</span>
                                                                        <br />
                                                                        <template v-if="eventItem.isEditing">
                                                                            <v-row>
                                                                                <v-col cols="3">
                                                                                    <v-currency-field
                                                                                        :disabled="dataset.loading && !($check(user, ['events.update.eventitem']))"
                                                                                        label="Valor" dense
                                                                                        aria-label="Digite o valor"
                                                                                        v-model="editedPartialAmount"
                                                                                        :allowNegative="false"
                                                                                        hide-details="auto" outlined>
                                                                                    </v-currency-field>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </template>
                                                                        <template v-else>
                                                                            <span
                                                                                class="section-info-value text-uppercase">
                                                                                {{
                                                                                    eventItem.currency |
                                                                                enum(dataset.currencyTypes, 'id',
                                                                                    'currencyFormat')
                                                                                }}
                                                                                {{ eventItem.partial_amount | currency
                                                                                }}
                                                                            </span>
                                                                        </template>
                                                                    </p>
                                                                    <p>
                                                                        <span class="section-info-title">Número
                                                                            pedido</span>
                                                                        <br />
                                                                        <template v-if="eventItem.isEditing">
                                                                            <v-row>
                                                                                <v-col cols="3">
                                                                                    <v-text-field
                                                                                        v-model="editedRequestNumber"
                                                                                        outlined dense
                                                                                        hide-details="auto"
                                                                                        :disabled="!($check(user, ['events.update.eventitem']))">
                                                                                    </v-text-field>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </template>
                                                                        <template v-else>
                                                                            <span
                                                                                class="section-info-value text-uppercase">
                                                                                {{ eventItem.request_number }}
                                                                            </span>
                                                                        </template>
                                                                    </p>

                                                                </template>


                                                                <p>
                                                                    <span class="section-info-title">Observações</span>
                                                                    <br />
                                                                    <span class="section-info-value text-uppercase">
                                                                        {{ eventItem.observation ?
                                                                            eventItem.observation
                                                                            : 'Não há observações registradas' }}</span>
                                                                </p>

                                                                <p>
                                                                    <span class="section-info-title">Motivo</span>
                                                                    <br />

                                                                    <template v-if="eventItem.isEditing">
                                                                        <v-row>
                                                                            <v-col cols="12">
                                                                                <tiptap-vuetify
                                                                                    class="custom-editor-short"
                                                                                    v-model="editedReason"
                                                                                    :rules="[$rules.required]"
                                                                                    :extensions="extensions"
                                                                                    hide-details="auto" />
                                                                                    <v-tooltip bottom>
                                                                                        <template #activator="{ on }">
                                                                                            <v-icon v-on="on" @click="openDialogDynamicText('editedReason')" class="me-2">
                                                                                                mdi-text-long
                                                                                            </v-icon>
                                                                                        </template>
                                                                                        <span>Selecionar textos longos predefinidos</span>
                                                                                    </v-tooltip>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span v-if="!eventItem.reason"
                                                                            class="section-info-value text-uppercase">
                                                                            Não há motivos registrados
                                                                        </span>
                                                                        <div v-else v-html="eventItem.reason"></div>
                                                                    </template>


                                                                </p>
                                                                <p>
                                                                    <span class="section-info-title"
                                                                        color="red">Contraditório</span>
                                                                    <br />

                                                                    <template v-if="eventItem.contradictory_reason">
                                                                        <v-chip small label class="mr-10 mt-4"
                                                                            :color="getColorByStatus(eventItem.contradictory_status)">
                                                                            {{ eventItem.contradictory_status |
                                                                            enum(dataset.eventStatus, 'id',
                                                                                'name') }}
                                                                        </v-chip>
                                                                        <br />
                                                                        <br />
                                                                        <strong>Valor indicado: </strong>
                                                                        <span v-if="eventItem.contradictory_amount">
                                                                            {{ eventItem.contradictory_amount |
                                                                                currency }}
                                                                        </span>
                                                                        <span v-else>N/A</span>
                                                                        <br />
                                                                        <br />
                                                                        <strong>Documentos: </strong>
                                                                        <template v-if="eventItem.contradictory_docs">
                                                                            <br />
                                                                            <span
                                                                                v-for="(item, index) in resolveContradictoryDocs()"
                                                                                :key="index">
                                                                                - <a :href="item">{{ item }}</a><br />
                                                                            </span>
                                                                        </template>
                                                                        <span v-else>N/A</span>
                                                                        <br />
                                                                        <br />
                                                                        <strong>Motivo </strong>
                                                                        <br />
                                                                        <div v-html="eventItem.contradictory_reason">
                                                                        </div>
                                                                    </template>

                                                                </p>

                                                                <p>
                                                                    <span class="section-info-title">Documentos</span>
                                                                    <br />
                                                                    <span class="section-info-value">{{
                                                                        eventItem.docs.length
                                                                        }}
                                                                        arquivo(s)</span>
                                                                </p>
                                                                <!-- <v-row>
                                                                <v-col v-for="(docItem, docIndex ) in eventItem.docs" :key="docIndex">
                                                                    <v-img @click="openDoc(docItem.doc.file_url)"
                                                                        class="rounded-xl"
                                                                        lazy-src="https://picsum.photos/id/11/10/6"
                                                                        :height="100" :width="100"
                                                                        :src="docItem.doc.file_url"></v-img>
                                                                </v-col>
                                                            </v-row> -->
                                                                <v-divider v-if="eventItem.docs.length > 0"></v-divider>
                                                                <br>
                                                                <v-row
                                                                    v-for="category in getEventItemsByCategory(eventItem)"
                                                                    :key="category.id">
                                                                    <v-col cols="12">
                                                                        <h3>{{ category.name }}</h3>
                                                                        <br>
                                                                        <v-row>
                                                                            <v-col v-for="doc in category.docs"
                                                                                :key="doc.id" cols="auto">
                                                                                <v-img @click="openDoc(doc.file_url)"
                                                                                    :class="['rounded-xl', verifyIsRequestedDoc(doc) ? 'doc-active-class' : 'doc-inactive-class']"
                                                                                    lazy-src="https://picsum.photos/id/11/10/6"
                                                                                    :height="100" :width="100"
                                                                                    :src="doc.file_url">
                                                                                </v-img>
                                                                                {{ doc.name }}
                                                                                <br>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>
                                                    </v-expansion-panel-content>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                        </div>
                                    </v-col>
                                </v-row>
                                <!-- <v-row>
                                    <v-col>
                                        <v-divider></v-divider>
                                    </v-col>
                                </v-row> -->
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row v-if="dataset.data.requested_doc">
            <v-col cols="12">
                <v-row>
                    <v-col cols="12">
                        <v-card class="card-form-outlined" color="gray">
                            <v-card-title class="card-group-title">
                                <div class="title-container">
                                    <div class="title-block">
                                        <span id="title" class="table-card-title">Documentos solicitados</span>
                                    </div>
                                </div>
                            </v-card-title>
                            <v-card-text v-for="(item, index) in getRequestDoc()" :key="index">
                                <v-row v-for="(doc, indexDoc) in item.docs" :key="indexDoc">
                                    <v-col v-if="doc">
                                        <span v-if="item.user_event_item_id" class="primary--text" color="primary">
                                            - <strong>Negócio #{{ item.user_event_item_id }}: </strong>
                                            <template v-if="doc.id != 50">
                                                {{ doc.id | enum(businessDocTypes, 'id', 'name') }}
                                            </template>
                                            <template v-else>
                                                {{ doc.customName || doc.name }}
                                            </template>
                                        </span>
                                        <span v-else-if="doc.id != 3" class="primary--text" color="primary">
                                            - {{ doc.id | enum(creditorEmailDocTypes, 'id', 'name') }}
                                        </span>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-row v-if="$check(user, ['events.update.files'])">
            <v-col cols="12">
                <v-row>
                    <v-col cols="12">
                        <v-card class="card-form-outlined" color="gray">
                            <v-card-title class="card-group-title">
                                <div class="title-container">
                                    <div class="title-block">
                                        <span id="title" class="table-card-title">Documento apoio</span>
                                    </div>
                                </div>
                            </v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12">
                                        <v-file-input dense accept="image/png, image/jpeg, application/pdf"
                                            prepend-icon="" outlined counter
                                            hint="O arquivo não pode ser superior a 15MB" hide-details="auto"
                                            label="Documento" :clearable="true" @change="onFileSelected($event)"
                                            show-size truncate-length="50" ref="file"
                                            :disabled="!($check(user, ['events.update.files']))">
                                        </v-file-input>

                                    </v-col>
                                </v-row>
                            </v-card-text>

                            <v-card-text>

                                <template>
                                    <v-row class="mt-n5">
                                        <v-col cols="12">
                                            <v-btn class="mr-4" type="button" elevation="0" color="primary"
                                                :disabled="!($check(user, ['events.update.files']))"
                                                :loading="dataset.loading" @click="updateHelpDoc()">{{
                                                    dataset.data.help_doc_url ? 'Atualizar' : 'Salvar' }}
                                            </v-btn>
                                            <v-btn type="button" elevation="0" color="primary" outlined
                                                v-if="dataset.data.help_doc_url" :href="dataset.data.help_doc_url"
                                                target="_blank">Visualizar
                                                documento
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-card-text>

                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-row v-if="$check(user, ['events.view.comments'])">
            <v-col cols="12">
                <v-row>
                    <v-col cols="12">
                        <v-card class="card-form-outlined" color="gray">
                            <v-card-title class="card-group-title">
                                <div class="title-container">
                                    <div class="title-block">
                                        <span id="title" class="table-card-title">Comentários</span>
                                    </div>
                                </div>
                            </v-card-title>
                            <v-card-text v-for="(item, index) in dataset.data.comments" :key="index">
                                <v-row>
                                    <v-col>
                                        <span class="primary--text" color="primary">{{ item.admin ? item.admin.name :
                                            "" }}
                                            <strong>({{ item.created_at | defaultDate }})</strong></span>
                                        <br>
                                        <div v-html="item.comments.toString().trim()" class="div-comments"></div>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-card-text>
                                <v-row>
                                    <v-col>
                                        <v-divider></v-divider>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <p class="font-weight-bold">Novo comentário</p>
                                        <tiptap-vuetify class="custom-editor-short"
                                            :disabled="dataset.data.status !== 0 && !($check(user, ['events.create.comment']))"
                                            v-model="dataset.comment" :rules="[$rules.required]"
                                            :extensions="extensions" hide-details="auto" />
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col>
                                        <v-btn type="button" elevation="0" color="primary" @click="saveComment"
                                            :disabled="!($check(user, ['events.create.comment']))">Salvar
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-row v-if="$check(user, ['events.view.reason'])">
            <v-col cols="12">
                <v-row>
                    <v-col cols="12">
                        <v-card class="card-form-outlined" color="gray">
                            <v-card-title class="card-group-title">
                                <div class="title-container">
                                    <div class="title-block">
                                        <span id="title" class="table-card-title">Motivo</span>
                                        <br>
                                        <span class="text-subtitle-2 text-none font-weight-medium">Motivo para aprovação
                                            ou
                                            rejeição</span>
                                    </div>
                                </div>
                            </v-card-title>
                            <v-card-text>

                                <v-row>
                                    <v-col cols="12">
                                        <p class="font-weight-bold">Texto curto</p>
                                        <tiptap-vuetify class="custom-editor-short" :disabled="(dataset.data.status == 1 || dataset.data.status == 2 || dataset.data.status == 3)
                                            && !($check(user, ['events.update.reason']))"
                                            v-model="dataset.data.smallReason" :rules="[$rules.required]"
                                            :extensions="extensions" hide-details="auto"
                                            @input="smallReasonUpdateRemainingChars" @keydown="smallReasonCheckMaxChars"
                                            @paste.native="smallReasonUpdateRemainingChars" />
                                        <div class="char-counter">
                                            <span :class="{ 'text-red': dataset.smallReasonRemainingChars <= 5 }">
                                                {{ dataset.smallReasonRemainingChars }} / {{ dataset.smallReasonMaxChars
                                                }}
                                            </span>
                                        </div>
                                        <v-alert v-if="dataset.smallReasonShowExceedMessage" type="error" dense>
                                            O texto excede o limite máximo de {{ dataset.smallReasonMaxChars }}
                                            caracteres.
                                        </v-alert>
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon v-on="on" @click="openDialogDynamicText('smallReason')" class="me-2">
                                                    mdi-text-short
                                                </v-icon>
                                            </template>
                                            <span>Selecionar textos curtos predefinidos</span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12">
                                        <p class="font-weight-bold">Texto longo</p>
                                        <tiptap-vuetify class="custom-editor-long" :disabled="(dataset.data.status == 1 || dataset.data.status == 2 || dataset.data.status == 3)
                                            && !($check(user, ['events.update.reason']))" v-model="dataset.data.reason"
                                            :rules="[$rules.required]" :extensions="extensions" hide-details="auto"
                                            @input="reasonUpdateRemainingChars" @keydown="reasonCheckMaxChars"
                                            @paste.native="reasonUpdateRemainingChars" />
                                        <div class="char-counter">
                                            <span :class="{ 'text-red': dataset.reasonRemainingChars <= 10 }">
                                                {{ dataset.reasonRemainingChars }} / {{ dataset.reasonMaxChars }}
                                            </span>
                                        </div>
                                        <v-alert v-if="dataset.reasonShowExceedMessage" type="error" dense>
                                            O texto excede o limite máximo de {{ dataset.reasonMaxChars }} caracteres.
                                        </v-alert>

                                        <!-- <v-btn v-if="dataset.data.status === 0" type="button" elevation="0" color="primary"
                                            outlined class="mt-5" @click="openDialogDynamicText(false);">Adicionar
                                            texto</v-btn>-->
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon v-on="on" @click="openDialogDynamicText('reason')" class="me-2">
                                                    mdi-text-long
                                                </v-icon>
                                            </template>
                                            <span>Selecionar textos longos predefinidos</span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>
                                <v-row v-if="$check(user, ['events.update.reason'])">
                                    <v-col>
                                        <v-btn type="button" elevation="0" color="primary" @click="saveReason">Salvar
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-row v-if="$check(user, ['events.view.logs'])">
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Movimentações</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text v-for="(item, index) in dataset.logs" :key="index">
                        <v-row>
                            <v-col>
                                <span class="text-uppercase font-weight-bold primary--text" color="primary">{{
                                    item.created_at | defaultDate }}:</span> {{ item.description }}
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-text v-if="!dataset.logs.length">
                        <v-row>
                            <v-col cols="12">
                                Nenhuma movimentação encontrada
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="dialogDynamicText" :width="900">
            <v-card>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <div class="font-weight-bold mt-6 title-page">Textos Automáticos</div>
                            <p class="mt-2">
                                Selecione um texto abaixo para adicionar no motivo
                            </p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <div>
                                <v-list-item two-line
                                    v-for="(item, index) in dataset.dynamicTexts.filter((x) => (targetField == 'smallReason' && x.small_description) || (targetField != 'smallReason' && x.description))"
                                    :key="index" style="cursor: pointer" @click="selectDynamicText(item)">
                                    <v-list-item-content>
                                        <v-list-item-title class="font-weight-bold">{{ item.name }}</v-list-item-title>
                                        <v-list-item-subtitle>
                                            <div
                                                v-html="targetField == 'smallReason' ? item.small_description : truncateText(item.description, 150)">
                                            </div>
                                            <v-divider></v-divider>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </div>
                            <!-- <v-card class="rounded-lg mb-10" v-for="(item, index) in dataset.dynamicTexts" :key="index"
                                elevation="2">
                                <v-card-title>
                                    {{ item.name }}
                                </v-card-title>
                                <v-card-text>
                                    <div v-html="dynamicTextSmallType ? item.small_description : item.description"></div>
                                </v-card-text>
                            </v-card> -->
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-btn type="button" elevation="0" color="error"
                                @click="dialogDynamicText = false;">Cancelar</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogRequestDoc" max-width="700px">
            <v-card>

                <v-card-title class="text-center text--darken-2"
                    style="border-bottom: 4px solid #007bff; padding-bottom: 8px; display: flex; justify-content: center; align-items: center;">
                    Seleção de Documentos
                </v-card-title>

                <v-card-text>
                    <v-container class="pa-0">
                        <br>
                        <p>
                            Selecione o(s) documento(s) que deseja solicitar ao credor <strong>{{ dataset.data.user &&
                                dataset.data.user.name
                                }}</strong>.
                        </p>
                        <v-checkbox v-for="doc in creditorBusinessDocType" :key="doc.id" :label="doc.name" :value="doc.id"
                            v-model="selectedRequestDocs" class="mt-0 mb-0"
                            @change="handleDocumentSelection(doc.id)"></v-checkbox>
                        <div v-if="selectedRequestDocs.includes(3)">
                            <v-divider class="my-4"></v-divider>
                            <span class="font-weight-bold">
                                Selecione o(s) Documento(s) do(s) negócio(s):
                            </span>
                            <v-expansion-panels>
                                <v-expansion-panel v-for="item in dataset.data.items" :key="item.id">
                                    <v-expansion-panel-header>
                                        <div class="d-flex align-center">
                                            <strong>Origem: </strong>
                                            <span class="ml-2 mr-2">
                                                {{
                                                    truncateText(
                                                        item.origin || 'N/A',
                                                        30
                                                    )
                                                }}
                                            </span>
                                            /
                                            <strong class="ml-2">Valor: </strong>
                                            <span class="ml-2" v-if="item.amount">
                                                {{
                                                    item.currency | enum(
                                                        dataset.currencyTypes,
                                                        'id',
                                                        'currencyFormat'
                                                    )
                                                }}
                                                {{ item.amount | currency }}
                                            </span>
                                            <span v-else>N/A</span>

                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-checkbox v-for="doc in businessDocTypes" :key="doc.id" :label="doc.name"
                                            :value="doc.id" v-model="selectedBusinessDocs[item.id].docs"
                                            class="mt-0 mb-0" :disabled="!selectedBusinessDocs[item.id]"
                                            :input-value="selectedBusinessDocs[item.id] && selectedBusinessDocs[item.id].docs.includes(doc.id)"
                                            @change="handleDocumentSelection(doc.id, item.id)"></v-checkbox>

                                        <v-text-field
                                            v-if="selectedBusinessDocs[item.id] && selectedBusinessDocs[item.id].docs.includes(50)"
                                            v-model="selectedBusinessDocs[item.id].customName"
                                            label="Especifique o documento" outlined dense></v-text-field>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </div>
                        <br>
                        <v-row>
                            <v-col>
                                <v-card outlined>
                                    <v-card-text>
                                        <v-row class="align-center">
                                            <v-col cols="12" sm="12" class="d-flex align-center">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <div v-bind="attrs" v-on="on">
                                                            <v-switch v-model="dataset.analysis_return"
                                                                label="Retornar para análise mesmo sem documentos"
                                                                hide-details class="mt-n2"
                                                                @change="switchChange"></v-switch>
                                                        </div>
                                                    </template>
                                                    <span>Se ativado, este pedido retornará para análise mesmo que o
                                                        credor não
                                                        tenha enviado os documentos solicitados.</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :loading="dataset.loading" type="button" elevation="0" color="primary"
                        @click="sendSelectedList">
                        Solicitar
                    </v-btn>
                    <v-btn color="grey" text @click="closeDialogRequestDoc">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--Modal adicionar um novo negocio-->
        <v-dialog v-model="dialogCreateBusiness" class="elevation-0" max-width="800px">

            <v-card>
                <v-card-title class="card-title">
                    Adicionar negócio
                </v-card-title>
                <br>
                <v-card-text>
                    <v-form ref="newBusinessForm" v-model="dataForm.validForm">
                        <v-row>
                            <v-col cols="12">
                                <span class="mr-3"><strong>Selecione a origem do crédito</strong></span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small :color="'primary'" v-bind="attrs"
                                            v-on="on">mdi-help-circle</v-icon>
                                    </template>
                                    <span>Selecione o motivo que gerou os valores do crédito</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>

                        <v-row class="mt-n4">
                            <v-col cols="12" sm="12">
                                <v-autocomplete :disabled="dataset.loading" dense required
                                    :items="dataset.creditorOriginTypes" label="Selecione a origem do crédito"
                                    v-model="dataset.newBusiness.origin" item-value="name" item-text="name"
                                    :rules="[$rules.required]" outlined hide-details="auto"></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <span class="mr-3"><strong>Informe a moeda e o valor referente ao
                                        negócio</strong></span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small :color="'primary'" v-bind="attrs"
                                            v-on="on">mdi-help-circle</v-icon>
                                    </template>
                                    <span>Informe o tipo de moeda e o valor devido</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>

                        <v-row class="mt-n4">
                            <v-col cols="12" sm="6">
                                <v-select :disabled="dataset.loading" dense id="type" :items="dataset.currencyTypes"
                                    label="Selecione uma moeda" v-model="dataset.newBusiness.currency" item-value="id"
                                    item-text="name" :rules="[$rules.required]" outlined hide-details="auto"></v-select>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-currency-field :disabled="dataset.loading" label="Valor" dense
                                    aria-label="Digite o valor do negócio" v-model="dataset.newBusiness.amount"
                                    :allowNegative="false" hide-details="auto" outlined required
                                    :rules="[$rules.required]"></v-currency-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <span class="mr-3"> <strong>Selecione a empresa devedora</strong></span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small :color="'primary'" v-bind="attrs"
                                            v-on="on">mdi-help-circle</v-icon>
                                    </template>
                                    <span>Selecione a empresa devedora do crédito</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>

                        <v-row class="mt-n4">
                            <v-col cols="12" sm="12">
                                <v-autocomplete :disabled="dataset.loading" dense required :items="dataset.clients"
                                    label="Selecione a devedora" v-model="dataset.newBusiness.company_name"
                                    item-value="name" item-text="name" :rules="[$rules.required]" outlined
                                    hide-details="auto"></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <span class="mr-3"> <strong>Informe o número de identificação do
                                        pedido/cotação/contrato/outro</strong></span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small :color="'primary'" v-bind="attrs"
                                            v-on="on">mdi-help-circle</v-icon>
                                    </template>
                                    <span>Informe o número de identificação do pedido</span>
                                </v-tooltip>

                            </v-col>

                        </v-row>
                        <v-row class="mt-n4">
                            <v-col cols="12">
                                <v-text-field :disabled="dataset.loading" dense label="Identificação do pedido"
                                    v-model="dataset.newBusiness.request_number"
                                    aria-label="Digite o numero de identificação do pedido" outlined hide-details="auto"
                                    :rules="[$rules.required]">
                                </v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="6">
                                <span class="mr-3"> <strong>Informe a classe no
                                        processo</strong></span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small :color="'primary'" v-bind="attrs"
                                            v-on="on">mdi-help-circle</v-icon>
                                    </template>
                                    <span>Selecione a classe no processo</span>
                                </v-tooltip>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <span class="mr-3">
                                    <strong>
                                        Data da ocorrência do negócio
                                    </strong>
                                </span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small :color="'primary'" v-bind="attrs"
                                            v-on="on">mdi-help-circle</v-icon>
                                    </template>
                                    <span>
                                        Informe a data do negócio
                                    </span>
                                </v-tooltip>
                            </v-col>
                        </v-row>

                        <v-row class="mt-n4">
                            <v-col cols="12" sm="6">
                                <v-select dense :items="dataset.creditorTypes" label="Classe"
                                    v-model="dataset.newBusiness.type" item-value="id" item-text="name" outlined
                                    hide-details="auto" :rules="[$rules.required]">
                                </v-select>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-text-field dense type="date" label="Data" v-model="dataset.newBusiness.ref_date"
                                    outlined hide-details="auto">
                                </v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <span class="mr-3">
                                    <strong>Adicione documento(s) comprobatório(s) do negócio</strong>
                                </span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small :color="'primary'" v-bind="attrs"
                                            v-on="on">mdi-help-circle</v-icon>
                                    </template>
                                    <span>Documentos que comprovem a origem do negócio</span>
                                </v-tooltip>
                            </v-col>

                            <v-col cols="12" lg="12" class="mt-n4">
                                <v-text-field outlined dense readonly hide-details :rules="[filesRequired]"
                                    prepend-icon="mdi-paperclip" :disabled="dataset.loading" @click="triggerFileInput">
                                    <template v-slot:prepend-inner>
                                        <div class="d-flex flex-wrap align-left v-chips-container">
                                            <v-chip v-for="(file, index) in dataset.newBusiness.docs" :key="index"
                                                class="ma-1" outlined small close @click:close="removeFile(index)">
                                                {{ file.name }}
                                            </v-chip>
                                        </div>
                                    </template>
                                </v-text-field>

                                <v-file-input ref="fileInput" dense multiple hide-input @change="addFiles"
                                    style="display: none"></v-file-input>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <span class="mr-3"><strong>Informe uma observação referente ao negócio</strong></span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small :color="'primary'" v-bind="attrs"
                                            v-on="on">mdi-help-circle</v-icon>
                                    </template>
                                    <span>Informações adicionais referente ao negócio</span>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="12" class="mt-n4">
                                <v-textarea :disabled="dataset.loading" dense id="description"
                                    label="Informações Adicionais" :rules="[
                                        $rules.maxlength(
                                            dataset.newBusiness.observation,
                                            500
                                        )
                                    ]" counter="500" v-model="dataset.newBusiness.observation" outlined
                                    hide-details="auto" rows="2" auto-grow></v-textarea>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-row class="mt-n5 mr-1 justify-end">
                        <v-col cols="auto">
                            <v-tooltip bottom>
                                <template #activator="{ on }">
                                    <v-btn v-on="on" color="primary" :loading="dataset.loadingSave"
                                        @click.native="saveNewBusiness">
                                        Salvar
                                    </v-btn>
                                </template>
                                <span>Salvar alterações</span>
                            </v-tooltip>

                            <v-tooltip bottom>
                                <template #activator="{ on }">
                                    <v-btn class="ml-4" v-on="on" type="button" elevation="0" color="primary" outlined
                                        @click="closeDialogCreateBusiness()">
                                        Cancelar
                                    </v-btn>
                                </template>
                                <span>Retornar sem salvar alterações</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogViewDoc" max-width="60%" @keydown.esc="cancel">
            <v-card>
                <v-img :src="selectedDoc" alt="" contain />
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import states from "@/common/data/states.data"
import string from "@/common/util/string"
import userEventUtil from "@/common/util/user-event.util"

import { cpf, cnpj } from 'cpf-cnpj-validator'

import userTypes from "@/common/data/user-types.data"
import currencyTypes from "@/common/data/currency-types.data"

import documentTypes from "@/common/data/document-types.data"
import creditorTypes from "@/common/data/creditor-types.data"
import eventStatus from "@/common/data/event-status.data"
import creditorEmailDocTypes from "@/common/data/creditor-email-doc-types.data"
import businessDocTypes from "@/common/data/business-doc-types.data"
import creditorOriginTypes from "@/common/data/creditor-origin-types.data.js";
import qgcRuleTypes from "@/common/data/qgc-rule-types.data.js";

import axios from "axios"

//import TiptapResizeImage from '@tiptap/extension-resize-image'; nao complica
// @tiptap/extension-im/age-resize -> Nao instala com NPM

//import Image from 'tiptap-extension-image-freely' // erro ao compilar

//import TiptapResizeImage from '@tiptap/extension-image'


import {
    TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History, Table, TableCell, TableHeader,
    TableRow
} from 'tiptap-vuetify'


export default {
    name: "UserDetails",

    components: { 'tiptap-vuetify': TiptapVuetify },

    data: () => ({
        user: null,
        page: {
            isNew: false,
            title: "",
        },
        targetField: '',
        selectedRequestDocs: [],
        selectedBusinesses: [],
        selectedBusinessDocs: {},
        customDocumentName: "",
        expandedPanels: [],
        documentTypes: documentTypes,
        creditorEmailDocTypes: creditorEmailDocTypes,
        creditorBusinessDocType: [{ id: 3, name: 'Documentos comprobatórios' }],
        businessDocTypes: businessDocTypes,
        dataset: {
            loadingReports: false,
            reports: [],
            qgcRuleTypes: qgcRuleTypes,
            userTypes: userTypes,
            currencyTypes: currencyTypes,
            eventStatus: eventStatus,
            breadcrumbItems: [],
            states: states,
            creditorTypes: creditorTypes,
            selectedItem: null,
            loading: false,
            loadingSave: false,
            logs: [],
            clients: [],
            analysis_return: false,
            creditorOriginTypes: creditorOriginTypes,
            newBusiness: {
                origin: null,
                amount: null,
                currency: null,
                company_name: null,
                request_number: null,
                type: null,
                ref_date: null,
                docs: [],
                observation: null,

            },
            data: {
                smallReason: "",
                reason: "",
                partialAmount: null,
                reasonDocument: null,
                helpDocument: null,
                processes: [],
                review_later: false,
            },
            partialItems: [],
            dynamicTexts: [],
            events: [],
            comment: "",
            smallReasonRemainingChars: 300,
            smallReasonMaxChars: 300,
            smallReasonShowExceedMessage: false,
            smallReasonIsDeleting: false,

            reasonRemainingChars: 5000,
            reasonMaxChars: 5000,
            reasonShowExceedMessage: false,
            reasonIsDeleting: false,

        },
        isEditing: false,
        editedAmount: null,
        editedPartialAmount: null,
        editedCurrency: null,
        editedReason: null,
        partialAmountError: '',
        editedRequestNumber: null,
        expandedPanel: null,
        progress: 0,
        dialogDynamicText: false,
        dialogPartialAccept: false,
        dynamicTextSmallType: false,
        selectedDoc: null,
        dialogViewDoc: false,
        dialogRequestDoc: false,
        dialogCreateBusiness: false,
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
            showPassword: false,
            showPasswordConfirmation: false,
        },

        extensions: [
            History,
            Blockquote,
            Link,
            Underline,
            Strike,
            Italic,
            ListItem,
            BulletList,
            OrderedList,
            [Heading, {
                options: {
                    levels: [1, 2, 3]
                }
            }],
            Bold,
            Code,
            HorizontalRule,
            Paragraph,
            HardBreak,
            [Table, {
                options: {
                    resizable: true
                }
            }],
            TableCell,
            TableHeader,
            TableRow,
        ],
        content: [
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: 'Exemplo de texto com uma imagem:'
                    },
                    {
                        type: 'image',
                        attrs: {
                            src: 'https://via.placeholder.com/150',
                            alt: 'Imagem de exemplo',
                            style: 'width: 150px; height: 150px;'
                        }
                    }
                ]
            }
        ],
    }),

    created() {
        this.setPage();
    },

    watch: {
        'dataset.data.smallReason': function () {
            this.smallReasonUpdateRemainingChars();
        },

        'dataset.data.reason': function () {
            this.reasonUpdateRemainingChars();
        },

        'dataset.data.items': {
            immediate: true,
            handler(newItems) {
                if (newItems) {
                    newItems.forEach(item => {
                        if (!this.selectedBusinessDocs[item.id]) {
                            this.$set(this.selectedBusinessDocs, item.id, {
                                docs: [],
                                origin: item.origin,
                                amount: item.amount,
                            });
                        } else {
                            this.selectedBusinessDocs[item.id].docs = this.selectedBusinessDocs[item.id].docs.map(doc => {
                                return typeof doc === 'object' ? doc : { id: doc, uploaded: false };
                            });
                        }
                    });
                }
            }
        }
    },

    mounted() {
        this.user = this.$root.user.data || this.$root.user;
        console.log(this.user)
        this.loadData();

        // this.initializeAnalysisStatus();
    },


    methods: {
        goBack() {
            this.$router.replace("/divergencias");
        },

        openDialogDynamicText(targetField) {
            this.loadDynamicTexts();
            this.targetField = targetField;
            this.dialogDynamicText = true;
        },

        switchChange(value) {
            console.log("🔄 Switch alterado para:", value);

            this.dataset.analysis_return = value;
        },

        async fetchAnalysisStatus(itemId) {
            try {
                const response = await axios.get(`/api/user-events/item-analysis/${itemId}`);
                if (response.status === 200) {
                    return response.data.content.analysis_status;
                } else {
                    console.error("Erro ao buscar o analysis_status:", response);
                    return 1;
                }
            } catch (error) {
                console.error("Erro ao buscar o analysis_status:", error);
                return 1;
            }
        },

        async initializeAnalysisStatus() {
            this.statusLoading = true;

            try {
                for (let i = 0; i < this.dataset.data.items.length; i++) {
                    const item = this.dataset.data.items[i];

                    const status = await this.fetchAnalysisStatus(item.id);
                    this.$set(this.dataset.data.items[i], 'isChecked', status === 2);
                }

                this.updateProgress();
            } catch (error) {
                console.error("Erro ao inicializar status:", error);
            } finally {
                this.statusLoading = false;
            }
        },

        editPartialAmount(eventItem) {
            this.dataset.data.items.forEach(item => {
                item.isEditingPartialAmount = false;
            });
            eventItem.isEditingPartialAmount = true;
            this.editedPartialAmount = eventItem.partial_amount;
        },

        updateProgress() {
            const totalItems = this.dataset.data.items.length || 0;
            const completedItems = this.dataset.data.items.filter(item => item.status !== 0 && item.status !== 4 && item.status !== 5).length || 0;
            this.progress = Math.round((completedItems / totalItems) * 100);
        },

        toggleCheckbox(eventItem) {
            eventItem.isEditing = false;
            this.expandedPanel = null;

            // Atualize o progresso ao mudar o status
            this.updateProgress();

            const newStatus = eventItem.isChecked ? 2 : 1;

            // Chamar o backend para atualizar o analysis_status
            this.updateBackend(eventItem.id, newStatus);
        },

        async updateBackend(itemId, analysisStatus) {
            try {
                const response = await axios.patch(`/api/user-events/item-analysis/${itemId}`, {
                    analysis_status: Number(analysisStatus)
                });

                if (response.status === 200) {
                    console.log("Analysis status atualizado com sucesso.");
                }
            } catch (error) {
                console.error("Erro ao atualizar o analysis status:", error);
            }
        },

        async saveReviewLater() {

            const isReviewLater = this.dataset.data.review_later;

            const proceedAction = await this.$dialog.confirm({
                text: isReviewLater
                    ? 'Tem certeza que deseja sinalizar o pedido?'
                    : 'Tem certeza que deseja desmarcar o pedido?',
                title: isReviewLater ? 'Sinalizar pedido' : 'Desmarcar pedido',
                actions: {
                    false: 'NÃO',
                    true: 'SIM',
                },
            });

            if (!proceedAction) {
                this.dataset.data.review_later = !isReviewLater;
                return;
            }

            const payload = { review_later: isReviewLater };

            try {
                await axios.patch(`/api/admin/user-events/review-event-later/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Alteração efetuada com sucesso!", {
                    position: "top-right",
                    timeout: 3000,
                });
            } catch (error) {
                this.dataset.data.review_later = !isReviewLater;

                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000,
                });
            }
        },

        async saveSelectedRule() {

            const selectedRule = this.dataset.data.user_creditor_rule;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja alterar a regra do pedido?',
                title: 'Alterar regra',
                actions: {
                    false: 'NÃO',
                    true: 'SIM',
                },
            });

            if (!proceedAction) {
                return;
            }

            const payload = { user_creditor_rule: selectedRule };

            try {
                await axios.patch(`/api/admin/user-events/qgc-rule/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Alteração efetuada com sucesso!", {
                    position: "top-right",
                    timeout: 3000,
                });
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000,
                });
            }
        },


        async saveCheckedItems() {
            const completedItems = this.dataset.data.items.filter(item => item.isChecked);
            // Aqui você pode enviar os dados para o backend
            await axios.post('/api/update-items', { items: completedItems });
            this.$dialog.notify.info("Itens salvos com sucesso!", { position: "top-right", timeout: 2000 });
        },

        editItem(eventItem, index) {
            this.dataset.data.items.forEach(item => {
                item.isEditing = false;
            });
            eventItem.isEditing = true;
            this.editedAmount = eventItem.amount;
            this.editedPartialAmount = eventItem.partial_amount;
            this.editedRequestNumber = eventItem.request_number;
            this.editedReason = eventItem.reason;

            // this.expandedPanel = index;
        },

        getFinalStatus() {
            if (!this.dataset.data || !this.dataset.data.items) return 0;

            const hasPending = this.dataset.data.items.some(item => item.status === 0 || item.status === 5);

            if (hasPending) return 0;

            if (this.dataset.data.items.every(item => item.status === 1)) return 1;

            if (this.dataset.data.items.every(item => item.status === 2)) return 2;

            return 3;
        },

        openRequestDoc() {

            this.dialogRequestDoc = true;
        },

        closeDialogCreateBusiness() {

            this.dataset.newBusiness.origin = null,
                this.dataset.newBusiness.amount = null,
                this.dataset.newBusiness.currency = null,
                this.dataset.newBusiness.company_name = null,
                this.dataset.newBusiness.request_number = null,
                this.dataset.newBusiness.type = null,
                this.dataset.newBusiness.ref_date = null,
                this.dataset.newBusiness.docs = [],
                this.dataset.newBusiness.observation = null,

                this.dialogCreateBusiness = false;
        },

        openCreateBusinessModal() {

            this.dialogCreateBusiness = true;
        },

        triggerFileInput() {
            const fileInput = this.$refs.fileInput.$el.querySelector('input[type="file"]');
            if (fileInput) {
                fileInput.click();
            }
        },

        filesRequired() {
            return this.dataset.newBusiness.docs.length > 0 || "Você deve adicionar pelo menos um documento!";
        },

        addFiles(files) {
            this.dataset.newBusiness.docs.push(...files);

            this.$refs.newBusinessForm && this.$refs.newBusinessForm.validate();
        },

        removeFile(index) {
            this.dataset.newBusiness.docs.splice(index, 1);

            this.$refs.newBusinessForm && this.$refs.newBusinessForm.validate();
        },

        verifyIsRequestedDoc(doc) {
            if (!this.dataset.data || !this.dataset.data.requested_doc) return false;

            let requestedDocs = JSON.parse(this.dataset.data.requested_doc || '[]');

            if (!Array.isArray(requestedDocs)) return false;

            let result = false;

            for (let item of requestedDocs) {
                if (item.user_event_item_id) {
                    for (let docItem of item.docs) {
                        if (docItem.ref_id == doc.ref_id) {
                            result = true;
                            continue;
                        }
                    }
                }
            }

            return result;
        },

        resolveContradictoryDocs() {
            if (!this.dataset.data || !this.dataset.data.contradictory_docs) return [];

            let docs = JSON.parse(this.dataset.data.contradictory_docs || '[]');

            return !Array.isArray(docs) ? [] : docs

        },

        getRequestDoc() {
            return JSON.parse(this.dataset.data.requested_doc || '[]')
        },

        getDocDescription(doc) {
            console.log('this.dataset.creditorEmailDocTypes ', this.dataset.creditorEmailDocTypes)
            return this.dataset.creditorEmailDocTypes.find((x) => x.id == doc) || "n/a"
        },

        formatValue(value, currency) {
            if (value === null || value === undefined) {
                return 'N/A';
            }

            let options = {
                style: 'currency',
                currency: 'BRL'
            };

            switch (currency) {
                case 1:
                    options.currency = 'BRL';
                    break;
                case 2:
                    options.currency = 'USD';
                    break;
                case 3:
                    options.currency = 'EUR';
                    break;
                default:
                    options.currency = 'BRL';
            }

            return new Intl.NumberFormat('pt-BR', options).format(value);
        },

        async loadCreditorReports() {

            this.dataset.loadingReport = true;

            try {
                const result = await axios.get(`/api/admin/reports/details/${this.dataset.data.user.registration.replaceAll('.', '').replaceAll('-', '').replaceAll('/', '')}`);

                this.dataset.reports = result.data.content;

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loadingReport = false;
            }
        },

        async loadClients() {
            try {
                const result = await axios.get(`/api/clients`, { params: { start: 1, limit: 100000, search: {} } });

                const data = result.data.content.data;

                data.sort((a, b) => a.name.localeCompare(b.name));

                this.dataset.clients = data;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            }
        },

        async saveNewBusiness() {

            if (!this.$refs.newBusinessForm.validate()) {
                this.$dialog.notify.error("Verifique se todos os campos obrigatórios foram preenchidos!", {
                    position: "top-right",
                    timeout: 5000,
                });

                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja adicionar o negócio?',
                title: 'Adicionar negócio',
                actions: {
                    false: 'Cancelar',
                    true: 'Adicionar'
                }
            })

            if (!proceedAction) return;

            const payload = this.newBusinessPayload();

            this.dataset.loadingSave = true;

            try {

                await axios.post(`/api/admin/user-events/event-item-create`, payload,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                this.$dialog.notify.success("Negócio adicionado com sucesso!", {
                    position: "top-right",
                    timeout: 5000,
                });

            } catch (error) {
                this.$dialog.notify.error("Erro ao adicionar o negócio!", {
                    position: "top-right",
                    timeout: 5000,
                });
            } finally {

                this.dataset.loadingSave = false;
                this.closeDialogCreateBusiness();
                this.loadData();
            }
        },

        newBusinessPayload() {

            const formData = new FormData();
            formData.append("event_id", this.dataset.data.id);
            formData.append("type", this.dataset.newBusiness.type);
            formData.append("amount", this.dataset.newBusiness.amount);
            formData.append("currency", this.dataset.newBusiness.currency);
            formData.append("origin", this.dataset.newBusiness.origin);
            formData.append("company_name", this.dataset.newBusiness.company_name);
            formData.append("ref_date", this.dataset.newBusiness.ref_date);
            formData.append("request_number", this.dataset.newBusiness.request_number);
            formData.append("observation", this.dataset.newBusiness.observation);

            if (this.dataset.newBusiness.docs && Array.isArray(this.dataset.newBusiness.docs)) {
                this.dataset.newBusiness.docs.forEach((file, index) => {
                    formData.append("docs[]", file);
                });
            }

            return formData;

        },


        handleDocumentSelection(docId, itemId) {
            if (!this.selectedRequestDocs.includes(3)) {
                for (const key in this.selectedBusinessDocs) {
                    if (this.selectedBusinessDocs[key].docs.length > 0) {
                        this.selectedBusinessDocs[key].docs = [];
                    }
                }
            }

            if (docId === 50) {

                if (!this.selectedRequestDocs.includes(50) && !itemId) {
                    this.customDocumentName = "";
                }

                if (itemId && !this.selectedBusinessDocs[itemId].docs.includes(50)) {
                    this.selectedBusinessDocs[itemId].customName = "";
                }
            }
        },

        closeDialogRequestDoc() {
            this.selectedRequestDocs = [];
            this.handleDocumentSelection();
            this.dialogRequestDoc = false;
        },

        async sendSelectedList() {

            const payload = this.requestedDocsPayload();

            if (!this.selectedRequestDocs || this.selectedRequestDocs.length === 0) {

                this.$dialog.notify.error(`Nenhum documento seleciondo!`, { position: "top-right", timeout: 3000 });

                return
            }

            if (this.selectedRequestDocs.includes(3)) {
                const hasBusinessDocs = Object.values(this.selectedBusinessDocs).some(
                    businessDoc => businessDoc.docs && businessDoc.docs.length > 0
                );

                if (!hasBusinessDocs) {
                    this.$dialog.notify.error(
                        `Documentos Comprobatórios está selecionado, mas nenhum documento dentro do(s) negócio(s) foi marcado!`,
                        { position: "top-right", timeout: 5000 }
                    );
                    return;
                }
            }

            this.dataset.loading = true;

            try {
                const response = await axios.patch(`/api/admin/user-events/creditor-doc-request/${this.$route.params.id}`, { docList: payload });

                await this.loadData()

                this.$dialog.notify.info("Solicitação enviada com sucesso!", { position: "top-right", timeout: 3000 });

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {

                this.dataset.loading = false;
                this.selectedRequestDocs = [];
                this.dataset.analysis_return = false;
                this.handleDocumentSelection();
                this.dialogRequestDoc = false;
            }

        },

        requestedDocsPayload() {
            const payload = [];

            for (const [itemId, { docs, origin, amount, customName }] of Object.entries(this.selectedBusinessDocs)) {
                if (docs.length > 0) {
                    const updatedDocs = docs.map(docId => {
                        const docPayload = {
                            id: docId,
                            uploaded: false,
                        };

                        if (docId === 50 && customName) {
                            docPayload.customName = customName;
                        }

                        return docPayload;
                    });

                    payload.push({
                        user_event_item_id: parseInt(itemId, 10),
                        docs: updatedDocs,
                        origin: origin,
                        amount: amount,
                    });
                }
            }

            if (this.selectedRequestDocs.length > 0) {
                const updatedDocs = this.selectedRequestDocs.map(docId => ({
                    id: docId,
                    uploaded: false,
                }));

                payload.push({
                    user_event_id: this.dataset.data.id || null,
                    analysis_return: this.dataset.analysis_return,
                    docs: updatedDocs,
                });
            }

            return payload;
        },

        async saveEdit(eventItem) {
            console.log("ISSO")
            if (this.partialAmountError) {
                this.$dialog.notify.error("Corrija os erros antes de salvar.", {
                    position: "top-right",
                    timeout: 2000,
                });
                return;
            }

            eventItem.amount = this.editedAmount;
            eventItem.partial_amount = this.editedPartialAmount;
            eventItem.request_number = this.editedRequestNumber;
            eventItem.reason = this.editedReason;
            eventItem.isEditing = false;

            this.editedAmount = null;
            this.editedPartialAmount = null;
            this.editedReason = null;
            this.editedReason = null;

            try {
                this.dataset.loading = true;

                const payload = {
                    type: eventItem.type,
                    amount: eventItem.amount,
                    partial_amount: eventItem.partial_amount,
                    request_number: eventItem.request_number,
                    company_name: eventItem.company_name,
                    currency: eventItem.currency,
                    origin: eventItem.origin,
                    reason: eventItem.reason
                };

                await this.updateEventItem(eventItem.id, payload);

                this.$dialog.notify.info("Dados atualizados com sucesso!", {
                    position: "top-right",
                    timeout: 2000,
                });
                eventItem.isEditing = false;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async changeStatusEventItem(eventItem, status) {

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja marcar o status como <strong>${userEventUtil.userEventStatusText(status)}</strong> do negócio <strong>#${eventItem.id}</strong>?`,
                title: `Confirmação`,
                actions: {
                    false: 'Cancelar',
                    true: 'Confirmar'
                }
            })

            if (!proceedAction) return;

            try {
                this.dataset.loading = true;

                await axios.patch(`/api/admin/user-events/item/action/${eventItem.id}`, { status });

                this.$dialog.notify.info("Status definido com sucesso!", {
                    position: "top-right",
                    timeout: 2000,
                });

                await this.loadData()
            } catch (error) {
                this.$dialog.notify.error("Erro ao atualizar os dados.", {
                    position: "top-right",
                    timeout: 2000,
                });
            } finally {
                this.dataset.loading = false;
            }
        },

        async updateHelpDoc() {

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja atualizar o documento de apoio?`,
                title: `Confirmação`,
                actions: {
                    false: 'Cancelar',
                    true: 'Confirmar'
                }
            })

            if (!proceedAction) return;

            try {
                this.dataset.loading = true;

                const formData = new FormData();

                formData.append("help", this.dataset.data.helpDocument)

                await axios.patch(`/api/admin/user-events/help-doc/${this.dataset.data.id}`, formData);

                this.$dialog.notify.info("Documento atualizado com sucesso!", {
                    position: "top-right",
                    timeout: 2000,
                });

                await this.loadData()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async updateReview(status) {

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja marcar o status como <strong>${userEventUtil.userEventStatusText(status)}</strong> da revisão?`,
                title: `Confirmação`,
                actions: {
                    false: 'Cancelar',
                    true: 'Confirmar'
                }
            })

            if (!proceedAction) return;

            try {
                this.dataset.loading = true;

                await axios.patch(`/api/admin/user-events/review/update/${this.dataset.data.id}`, { status });

                this.$dialog.notify.info("Revisão concluída com sucesso!", {
                    position: "top-right",
                    timeout: 2000,
                });

                await this.loadData()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async saveReason() {
            if (!this.dataset.data.smallReason || !this.dataset.data.reason) {
                this.$dialog.notify.error("Motivo é obrigatório", { position: "top-right", timeout: 2000 });
                return;
            }

            if (this.dataset.data.smallReason.length > 300) {
                console.log("qty_reason: ", this.dataset.data.smallReason.length)
                this.$dialog.notify.error("Motivo Curto excedeu a quantidade máxima de caracteres!", { position: "top-right", timeout: 2000 });
                return;
            }

            if (this.dataset.data.reason.length > 5000) {
                console.log("qty_reason: ", this.dataset.data.reason.length)
                this.$dialog.notify.error("Motivo Longo excedeu a quantidade máxima de caracteres!", { position: "top-right", timeout: 2000 });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja salvar o motivo?`,
                title: `Confirmação`,
                actions: {
                    false: 'Cancelar',
                    true: 'Confirmar'
                }
            })

            if (!proceedAction) return;

            try {
                this.dataset.loading = true;

                await axios.patch(`/api/admin/user-events/reason/update/${this.dataset.data.id}`, { smallReason: this.dataset.data.smallReason, reason: this.dataset.data.reason });

                this.$dialog.notify.info("Motivo salvo com sucesso!", {
                    position: "top-right",
                    timeout: 2000,
                });

                await this.loadData()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async saveComment() {
            if (!this.dataset.comment) {
                this.$dialog.notify.error("Comentário é obrigatório", { position: "top-right", timeout: 2000 });
                return;
            }

            if (this.dataset.comment.length > 1000) {
                this.$dialog.notify.error("Comentário excedeu a quantidade máxima de caracteres!", { position: "top-right", timeout: 2000 });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja salvar o comentário?`,
                title: `Confirmação`,
                actions: {
                    false: 'Cancelar',
                    true: 'Confirmar'
                }
            })

            if (!proceedAction) return;

            try {
                this.dataset.loading = true;

                await axios.patch(`/api/admin/user-events/comment/update/${this.dataset.data.id}`, { comment: this.dataset.comment, is_client: false });

                this.$dialog.notify.info("Comentário salvo com sucesso!", {
                    position: "top-right",
                    timeout: 2000,
                });

                await this.loadData()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async updateEventItem(itemId, payload) {
            await axios.patch(`/api/user-events/request/update/${itemId}`, payload);
        },

        cancelEditItem(eventItem) {
            this.editedAmount = eventItem.amount;
            this.editedPartialAmount = eventItem.partial_amount;
            this.editedRequestNumber = eventItem.request_number;
            eventItem.isEditing = false;
        },

        validatePartialAmount(eventItem) {
            if (this.editedPartialAmount > this.editedAmount) {
                this.partialAmountError =
                    "O valor parcial aceito não pode ser maior que o valor total.";
            } else {
                this.partialAmountError = "";
            }
        },


        savePartialAmount(eventItem) {
            eventItem.partial_amount = this.editedPartialAmount;
            eventItem.isEditingPartialAmount = false;
        },

        cancelPartialAmount(eventItem) {
            this.editedPartialAmount = eventItem.partial_amount;
            eventItem.isEditingPartialAmount = false;
        },

        editRequestNumber(eventItem) {
            this.dataset.data.items.forEach(item => {
                item.isEditingRequestNumber = false;
            });
            eventItem.isEditingRequestNumber = true;
            this.editedRequestNumber = eventItem.request_number;
        },

        saveRequestNumber(eventItem) {
            eventItem.request_number = this.editedRequestNumber;
            eventItem.isEditingRequestNumber = false;
        },

        cancelRequestNumber(eventItem) {
            this.editedRequestNumber = eventItem.request_number;
            eventItem.isEditingRequestNumber = false;
        },

        onFileSelected(file) {
            this.dataset.data.helpDocument = file;
        },

        smallReasonUpdateRemainingChars() {
            const currentLength = this.dataset.data.smallReason ? this.dataset.data.smallReason.length : 0;

            this.dataset.smallReasonRemainingChars = this.dataset.smallReasonMaxChars - currentLength;

            if (this.dataset.smallReasonRemainingChars < 0) {
                this.dataset.smallReasonShowExceedMessage = true;
            } else {
                this.dataset.smallReasonShowExceedMessage = false;
            }
        },

        reasonUpdateRemainingChars() {
            const currentLength = this.dataset.data.reason ? this.dataset.data.reason.length : 0;

            this.dataset.reasonRemainingChars = this.dataset.reasonMaxChars - currentLength;

            if (this.dataset.reasonRemainingChars < 0) {
                this.dataset.reasonShowExceedMessage = true;
            } else {
                this.dataset.reasonShowExceedMessage = false;
            }
        },

        smallReasonCheckMaxChars(event) {
            const currentLength = this.dataset.data.smallReason ? this.dataset.data.smallReason.length : 0;

            if (currentLength >= this.dataset.smallReasonMaxChars && event.key !== 'Backspace' && event.key !== 'Delete') {
                event.preventDefault();
            }

            this.dataset.smallReasonIsDeleting = event.key === 'Backspace' || event.key === 'Delete';
        },

        reasonCheckMaxChars(event) {
            const currentLength = this.dataset.data.reason ? this.dataset.data.reason.length : 0;

            if (currentLength >= this.dataset.reasonMaxChars && event.key !== 'Backspace' && event.key !== 'Delete') {
                event.preventDefault();
            }

            this.dataset.reasonIsDeleting = event.key === 'Backspace' || event.key === 'Delete';
        },


        getEventItemsByCategory(eventItem) {
            const categories = {};

            eventItem.docs.forEach(docItem => {
                const category_id = docItem.doc.type;

                if (!categories[category_id]) {
                    categories[category_id] = {
                        id: category_id,
                        name: this.getCategoryName(category_id),
                        docs: []
                    };
                }

                categories[category_id].docs.push({
                    id: docItem.id,
                    name: docItem.doc.name,
                    file_url: docItem.doc.file_url,
                    ref_id: docItem.doc.id
                });
            });

            return Object.values(categories);
        },

        getColorByStatus(status) {
            switch (status) {
                case 0:
                    return 'warning';
                case 1:
                    return 'accent';
                case 2:
                    return 'error';
                case 3:
                    return '#80CBC4';
                case 5:
                    return '#7E55AB';
                default:
                    return 'grey';
            }
        },

        getCategoryName(category_id) {
            return this.documentTypes.find(category => category.id === category_id).name;
        },

        openDoc(doc) {
            window.open(doc, '_blank');
            // this.selectedDoc = doc;
            // this.dialogViewDoc = true;
        },

        truncateText(text, maxLength) {
            return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
        },

        updateContraditory(value) {
            this.dataset.data.contradictory_deadline_at = value;
        },

        formatDate(date) {
            if (!date || date === "0000-00-00 00:00:00") return null;
            return this.$moment(date).format('YYYY-MM-DD');
        },

        getMessageByTypeEvent(item) {
            let result = '';

            switch (item.type) {
                case 'login-account':
                    result = `Usuário acessou o sistema no dia ${this.$moment(item.created_at).format('DD/MM/YYYY HH:mm')}`;
                    break;

                case 'accept-value':
                    result = `Usuário aceitou o crédito no valor de R$ ${this.dataset.data.requested_value} no dia ${this.$moment(item.created_at).format('DD/MM/YYYY HH:mm')}`;
                    break;

                case 'verify-account':
                    result = `Usuário verificou a conta no dia ${this.$moment(item.created_at).format('DD/MM/YYYY HH:mm')}`;
                    break;

                case 'register-user':
                    result = `Usuário criou a conta no dia ${this.$moment(item.created_at).format('DD/MM/YYYY HH:mm')}`;
                    break;

                case 'create-event':
                    result = `Usuário registrou uma divergência no dia ${this.$moment(item.created_at).format('DD/MM/YYYY HH:mm')}`;
                    break;

                default:
                    break;
            }

            return result;
        },

        getTitleByTypeEvent(item) {
            let result = '';

            switch (item.type) {
                case 'login-account':
                    result = `acesso`;
                    break;

                case 'accept-value':
                    result = `CRÉDITO`;
                    break;

                case 'verify-account':
                    result = `verificação`;
                    break;

                case 'register-user':
                    result = `cadastro`;
                    break;

                case 'create-event':
                    result = `divergência`;
                    break;

                default:
                    break;
            }

            return result;
        },

        async loadData() {
            this.user = this.$root.user.data || this.$root.user;

            this.dataset.loading = true;

            try {

                this.setPage();
                this.listBreadCrumbItems();

                await this.load();
                await this.loadLogs();

                await this.loadCreditorReports();

                this.updateProgress();

                this.loadClients();

                this.smallReasonUpdateRemainingChars();
                this.reasonUpdateRemainingChars();

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = `Detalhes do pedido`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Divergência",
                disabled: false,
                to: "/divergencias",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: `Detalhes do pedido`,
                disabled: true,
                exact: true,
            });
        },

        selectDynamicText(item) {
            
            if (this.targetField === 'smallReason') {
                this.dataset.data.smallReason += item.small_description;
            } else if (this.targetField === 'editedReason') {
                this.editedReason = (this.editedReason || '') + item.description;
            } else if (this.targetField === 'reason') {
                this.dataset.data.reason += item.description;
            }

            this.dialogDynamicText = false;

            this.smallReasonUpdateRemainingChars();
            this.reasonUpdateRemainingChars();
        },

        async updateStatus() {

            if (!this.dataset.data.smallReason || !this.dataset.data.reason) {
                this.$dialog.notify.error("Motivo é obrigatório", { position: "top-right", timeout: 2000 });
                return;
            }

            if (this.dataset.data.smallReason.length > 300) {
                console.log("qty_reason: ", this.dataset.data.smallReason.length)
                this.$dialog.notify.error("Motivo Curto excedeu a quantidade máxima de caracteres!", { position: "top-right", timeout: 2000 });
                return;
            }

            if (this.dataset.data.reason.length > 5000) {
                console.log("qty_reason: ", this.dataset.data.reason.length)
                this.$dialog.notify.error("Motivo Longo excedeu a quantidade máxima de caracteres!", { position: "top-right", timeout: 2000 });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja confirmar o pedido?`,
                title: `Confirmação`,
                actions: {
                    false: 'Cancelar',
                    true: 'Confirmar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const data = {
                smallReason: this.dataset.data.smallReason,
                reason: this.dataset.data.reason,
            }

            try {
                await axios.patch(`/api/admin/user-events/action/${this.$route.params.id}`, data)

                this.$dialog.notify.info(`Pedido confirmado com sucesso!`, { position: "top-right", timeout: 2000 });

                this.goBack();

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async createReview() {

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja enviar para revisão?`,
                title: `Confirmação`,
                actions: {
                    false: 'Cancelar',
                    true: 'Confirmar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            try {
                await axios.patch(`/api/admin/user-events/review/create/${this.$route.params.id}`)

                this.$dialog.notify.info(`Pedido enviado para revisão com sucesso!`, { position: "top-right", timeout: 2000 });

                this.goBack();

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async updateContradictoryDeadline() {

            if (!this.dataset.data.contradictory_deadline_at) {
                this.$dialog.notify.error("O campo Prazo é obrigatório", { position: "top-right", timeout: 2000 });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja atualizar o prazo para contraditórios?`,
                title: `Atualizar divergência`,
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            try {
                const response = await axios.patch(`/api/admin/user-events/contradictory-deadline/${this.$route.params.id}`, { contradictory_deadline_at: this.dataset.data.contradictory_deadline_at })

                this.$dialog.notify.info(`Divergência atualizada com sucesso!`, { position: "top-right", timeout: 2000 });

                this.goBack();

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async load() {

            try {
                const result = await axios.get(`/api/admin/user-events/find/${this.$route.params.id}`);

                const data = result.data.content;

                this.dataset.data = data;

                this.dataset.data = {
                    ...data,
                    items: data.items.map(item => ({
                        ...item,
                        isEditing: false,
                        isChanged: false,
                    })),
                };

                this.dataset.data.smallReason = data.small_reason || ""
                this.dataset.data.reason = data.reason || ""

                const registration = this.dataset.data.user.registration;

                if (registration) {
                    this.dataset.data.user.registration = registration.length < 14 ? cpf.format(registration) : cnpj.format(registration);
                }

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadLogs() {

            try {
                const result = await axios.get(`/api/admin/user-events/request/logs/${this.$route.params.id}`);

                const data = result.data.content.data;

                this.dataset.logs = data;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadDynamicTexts() {

            try {
                const result = await axios.get(`/api/admin/dynamic-texts`, { params: { start: 1, limit: 100000, search: {} } });

                this.dataset.dynamicTexts = result.data.content.data;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        buildPayload() {
            const data = {
                name: this.dataset.data.name,
                email: this.dataset.data.email,
                description: this.dataset.data.description,
                client: this.dataset.data.client,
                unit: this.dataset.data.unit,
                associations: this.normalizeAssociations(),
                credential: {
                    username: this.dataset.data.email,
                    password: this.dataset.data.password,
                },
                roles: this.dataset.data.roles

            }

            return data;
        },

        async statusReset(id) {

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja restaurar o pedido?',
                title: 'Restaurar',
                actions: {
                    false: 'Cancelar',
                    true: 'Restaurar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            try {
                await axios.patch(`/api/admin/user-events/restore/${this.$route.params.id}`, { status: 0 });

                this.$dialog.notify.info('Pedido restaurado com sucesso!', { position: "top-right", timeout: 2000 });

                this.goBack()

            } catch (error) {
                console.log("erro: ", error)
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        getCreditorTypeName(typeId) {
            const type = this.dataset.creditorTypes.find(item => item.id === typeId);
            return type ? type.name : 'N/A';
        },

        onAutocompleteChange(eventIndex) {
            this.$set(this.dataset.data.items[eventIndex], 'isChanged', true);
        },

        async updateClassType(eventItem, eventIndex) {

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja atualizar a classe do negócio?`,
                title: `Atualizar classe`,
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            const id = eventItem.id
            const type = eventItem.type

            this.dataset.loading = true;

            try {
                const response = await axios.patch(`/api/admin/user-events/class-type-change/${id}`, { type: type })

                this.$dialog.notify.info(`Classe atualizada com sucesso!`, { position: "top-right", timeout: 3000 });

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 3000
                })
            } finally {
                this.dataset.loading = false;
            }

            this.$set(this.dataset.data.items[eventIndex], 'isChanged', false);
        },

        async copyToClipboard(data) {
            await navigator.clipboard.writeText(data);

            this.$dialog.notify.info(`Copiado para área de transferência!`, { position: "top-right", timeout: 3000 });
        }
    },

};

</script>

<style lang="scss">
.checkbox-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    /* Certifique-se de que o checkbox esteja acima do painel */
    pointer-events: auto;
    transform: translateY(+3%);
    /* Garante clicabilidade */
}

.checkbox-marked-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    /* Certifique-se de que o checkbox esteja acima do painel */
    pointer-events: auto;
    /* Garante clicabilidade */
}

.loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    /* Altura mínima para manter consistência visual */
    text-align: center;
    color: #4caf50;
    /* Cor do texto combinando com o indicador */
}

.v-expansion-panel-header {
    position: relative;
    padding-left: 40px;
    /* Ajusta o espaço para o checkbox */
}

.centered {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 15px;
}

.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}

.custom-editor-short {
    .tiptap-vuetify-editor__content {
        min-height: 100px !important;
    }

    .ProseMirror {
        min-height: 100px !important;
    }
}

.custom-editor-long {
    .tiptap-vuetify-editor__content {
        min-height: 200px !important;
    }

    .ProseMirror {
        min-height: 200px !important;
    }
}

.icon-container {
    display: flex;
    align-items: center;
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 8px;
}

.image-resizer {
    display: inline-flex;
    position: relative;
    flex-grow: 0;
}

.image-resizer .resize-trigger {
    position: absolute;
    right: -6px;
    bottom: -9px;
    opacity: 0;
    transition: opacity .3s ease;
    color: #3259a5;
}

.image-resizer:hover .resize-trigger {
    opacity: 1;
}

.char-counter {
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
}

.text-red {
    color: red;
}

.caption-text {
    font-size: 12px;
    font-weight: bold;
    color: #444;
    margin-top: 15px;
}

.document-container {
    position: relative;
    width: 250px;
    height: 150px;
}

.overlay-link {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
}

.document-frame {
    width: 250px;
    height: 150px;
    border: none;
    overflow: hidden;
    scrolling: no;
}

.v-chips-container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
    margin-bottom: 5px;
}

.v-text-field .v-input__control {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.v-text-field .v-input__control>.v-chips-container {
    margin-right: auto;
}

.card-title {
    border-bottom: 4px solid #2373c9 !important;
    padding-bottom: 8px !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    // font-family: 'Raleway' !important;
    font-weight: 650 !important;
    font-size: 20px !important;
    font-style: bold !important;
    text-align: center !important;
}

.div-comments p {
    margin-bottom: 0px !important;
}

.doc-active-class {
    border: 2px solid #e74c3c;
    /* Vermelho bonito */
    border-radius: 12px;
    /* Arredondado para suavidade */
    box-shadow: 0 4px 8px rgba(231, 76, 60, 0.4);
    /* Sombra suave */
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    /* Efeito de interação */
}

.doc-inactive-class {
    border: 0px;
    border-radius: 12px;
    box-shadow: none !important;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}
</style>